<template>
    <layout :title="pageTitle" class="report-detail-wrapper add-report-wrapper">
        <div class="report-basic">
            <div class="report-basic-item">
                <div>地址</div>
                <div>{{report.examineAddress}}</div>
            </div>
            <div class="report-basic-item">
                <div>检测日期</div>
                <div>{{report.reportDate}}</div>
            </div>
        </div>
        <div class="report-eye-content report-content">
            <div class="group-title">
                <img src="../assets/img/eye.png" alt="">
                <span>视力情况</span>
            </div>
<!--            <div class="eys-param-item" style="margin-top: 25px">-->
<!--                <div class="title"><span>裸眼视力5M</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value">{{report.eyesight1}}</div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value">{{report.eyesight2}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>矫正视力1.0</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value">{{report.cva1}}</div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value">{{report.cva2}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>电脑验光数据</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value">{{report.optometry1}}</div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value">{{report.optometry2}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="eys-param-item" style="margin-top: 25px">
                <div class="title"><span>眼压(mmHg)</span></div>
                <div class="input-group">
                    <div class="left">
                        <div class="label">左眼</div>
                        <div class="value">{{report.iop1}}</div>
                    </div>
                    <div class="right">
                        <div class="label">右眼</div>
                        <div class="value">{{report.iop2}}</div>
                    </div>
                </div>
            </div>
            <div class="eys-param-item">
                <div class="title"><span>眼轴长度(mm)</span></div>
                <div class="input-group">
                    <div class="left">
                        <div class="label">左眼</div>
                        <div class="value">{{report.axl1}}</div>
                    </div>
                    <div class="right">
                        <div class="label">右眼</div>
                        <div class="value">{{report.axl2}}</div>
                    </div>
                </div>
            </div>
            <div class="eys-param-item">
                <div class="title"><span>角膜曲率(D)</span></div>
                <div class="input-group">
                    <div class="left">
                        <div class="label">左眼</div>
                        <div class="value">{{report.cornealCurvature1}}</div>
                    </div>
                    <div class="right">
                        <div class="label">右眼</div>
                        <div class="value">{{report.cornealCurvature2}}</div>
                    </div>
                </div>
            </div>
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>角膜厚度</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value">{{report.cornealThickness1}}</div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value">{{report.cornealThickness2}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>前房深度</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value">{{report.chamberDepth1}}</div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value">{{report.chamberDepth2}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>晶体厚度</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value">{{report.crystalThickness1}}</div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value">{{report.crystalThickness2}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>玻璃体厚度</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value">{{report.vitreumThickness1}}</div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value">{{report.vitreumThickness2}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>脉络膜厚度</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value">{{report.choroidThickness1}}</div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value">{{report.choroidThickness2}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="report-images" v-if="report.image">
                <img :src="report.image" alt="" class="image-item" @click="handlePreviewImage">
            </div>
        </div>
    </layout>
</template>

<script>
    import {ImagePreview} from 'vant';
    export default {
        name: "ReportDetail",
        data() {
            return {
                pageTitle: ' ',
                report:{}
            }
        },
        props: {
            id: String
        },
        methods: {

            handlePreviewImage() {
                ImagePreview({
                    images: [
                        this.report.image
                    ],
                    closeable: true,
                });
            },

            async loadReportDetail() {
                try {
                    let {data} = await this.$req.getReport({
                        id: this.id
                    });
                    this.pageTitle = data.memberName;
                    this.report = data;
                } catch (e) {
                    //TODO
                }
            }
        },
        mounted() {
            this.loadReportDetail();
        }
    }
</script>

<style scoped>

</style>